// Set a Cookie
export function setCookie(cName: string, cValue: string, expHours: number) {
    let date = new Date()
    date.setTime(date.getTime() + expHours * 60 * 60 * 1000)
    const expires = "expires=" + date.toUTCString()
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/"
}
